import { Controller } from "@hotwired/stimulus"

// Alterna entre los gráficos de tendencia (Glicemia / Colesterol) sin recargar la página.
export default class extends Controller {
  static targets = ["panel"]

  mostrar(event) {
    const serie = event.params.serie

    this.element.querySelectorAll("button[data-action*='indicadores-tendencia#mostrar']").forEach((boton) => {
      boton.classList.remove("is-activo")
    })
    event.currentTarget.classList.add("is-activo")

    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("d-none", panel.dataset.indicadoresTendenciaSerie !== serie)
    })
  }
}
